<!--
  - Copyright (c) 2025. Haodong JU
  -->

<template>
  <v-dialog
    v-model="dialog"
    max-width="900px"
    persistent
    scrollable
  >
    <v-card>
      <v-toolbar flat dense color="transparent">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="pt-4">
        <member-selector
          ref="memberSelector"
          v-model="selectedMemberIds"
          :multiple="multiple"
          :return-mode="returnMode"
          @selection-confirmed="confirm"
        ></member-selector>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="close"
        >
          取消
        </v-btn>
        <v-btn
          color="primary"
          :disabled="selectedMemberIds.length === 0"
          @click="confirm"
        >
          确认选择
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MemberSelector from './MemberSelector.vue'
import { useMemberSelectorStore } from '@/model/dataLayer/api/memberSelectorStore'

export default {
  name: 'MemberSelectorDialog',
  components: {
    MemberSelector
  },
  props: {
    title: {
      type: String,
      default: '选择会员'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    initialSelection: {
      type: Array,
      default: () => []
    },
    returnMode: {
      type: String,
      default: 'membership',
      validator: (value) => ['membership', 'user'].includes(value)
    }
  },
  data () {
    return {
      dialog: false,
      selectedMemberIds: [],
      resolvePromise: null,
      rejectPromise: null
    }
  },
  methods: {
    /**
     * Open the member selector dialog
     * @returns {Promise<Array>} Promise that resolves to an array of selected member IDs
     */
    open () {
      this.selectedMemberIds = [...this.initialSelection]
      this.dialog = true

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    /**
     * Close the dialog without selecting
     */
    close () {
      this.dialog = false
      if (this.rejectPromise) {
        this.rejectPromise('Selection cancelled')
      }
      this.resetState()
    },

    /**
     * Confirm the selection and close the dialog
     */
    confirm () {
      this.dialog = false
      if (this.resolvePromise) {
        this.resolvePromise([...this.selectedMemberIds])
      }
      this.resetState()
    },

    /**
     * Reset the internal state
     */
    resetState () {
      this.resolvePromise = null
      this.rejectPromise = null

      // Reset the store state
      const store = useMemberSelectorStore()
      store.resetFilters()
    }
  }
}
</script>
